module.exports = __webpack_public_path__ + "img/RASP.01f80ee8.png";